'use client'

import React, { FC, ReactElement } from 'react'
import styles from './InscriptionText.module.css'
import { fetcherText } from '@/utils/fetcher'
import { CDN_URL, CDN_PREVIEW_URL } from '@/utils/constants'
import classNames from 'classnames'
import useSWRImmutable from 'swr/immutable'
import Iframe from '@/components/iframe'
import OvO from './ovo'
import BRC420 from './brc420'

const renderers: Record<string, string> = {
	'ordinals-bixel': '3e5a7c9cc72a2c50f5ef5f467ea6fc88e00a55468c630ff8a49b6c6c55287c97i0',
	frescordinals: '8e3176c726d145fc91ec2f33f47a03f517fadfc95986b5fbf7afe67a15be7511i0',
	'the-time-standard': '7530beeda88e4957cbb29b9cd3d34a49a5a1b037be67a1d86f64cc993a8e52bfi0',
	'uwu-the-kawaii-standard': '1169aaf8218d40bb29c6a3dfe73ea60a54f8e88798578963b45885b9984fd26ci0',
	'ordinals-biixel': 'd471fe7fab0544b16072a74ba47357485b3329a233cef9f88b1c67082d644efci0'
}

function parseInscriptionJson(data: string | undefined) {
	try {
		const jsonObject = JSON.parse(data ?? '')
		return {
			jsonObject,
			prettyString: JSON.stringify(jsonObject, null, 2)
		}
	} catch {
		return {
			jsonObject: null,
			prettyString: undefined
		}
	}
}

const InscriptionText: FC<{
	inscriptionId: string
	className?: string
	textClassName: string
	imageClassName?: string
	collection?: any
}> = (props): ReactElement => {
	const { collection } = props
	const { data } = useSWRImmutable(`${CDN_URL}/${props.inscriptionId}`, fetcherText)

	const { jsonObject, prettyString } = parseInscriptionJson(data)

	if (jsonObject?.p === 'gen-brc-721' && jsonObject?.op === 'mint') {
		return (
			<img
				src={`${CDN_PREVIEW_URL}/${props.inscriptionId}`}
				className={classNames({
					[props?.className ?? '']: !!props?.className,
					[props?.imageClassName ?? '']: !!props?.imageClassName
				})}
				alt="Inscription"
			/>
		)
	}

	const renderer = renderers[props?.collection?.slug]

	if (renderer && data) {
		return <Iframe src={`${CDN_URL}/${renderer}?data=${data}`} className={props.className} />
	}

	if (collection?.slug === 'ovo' && data) {
		return <OvO className={props.className} num={parseInt(data.split('.')[0])} />
	}

	if (collection?.slug?.startsWith('brc420-') && data) {
		return <BRC420 id={data.split('/').slice(-1)[0]} className={props.className} />
	}

	return (
		<div className={classNames(styles.root, { [props.className ?? '']: !!props.className })}>
			<div
				className={classNames(styles.container, { [props.textClassName ?? '']: !!props.textClassName })}
			>
				<p>{prettyString ? prettyString : JSON.stringify(data)}</p>
			</div>
		</div>
	)
}

export default InscriptionText
